<template>
  <select>
    <slot></slot>
  </select>
</template>

<script>
import { eventBus } from '../../main'

export default {
  name: 'select2',
  props: ['options', 'value', 'configuration', 'optionsTriggerChange'],
  // placeholder: this.placeholder,
  mounted() {
    const vm = this

    function formatState(state, vm) {
      if (!state.id) {
        return state.text
      } else {
        const baseUrl = '/static/images/flags'
        const $state = $(
          '<span class="flag-select"><img src="' + baseUrl + '/flag' + state.id + '.png" class="img-flag" /> ' + state.text + '</span>',
        )
        return $state
      }
    }

    if ($(this.$el).attr('flags')) {
      $(this.$el)
      // init select2 "merge" data et configuration
        .select2(Object.assign({
          data: this.options,
          language: 'fr',
          templateResult: formatState,
          templateSelection: formatState,
        }, this.configuration))
        .val(this.value)
        .trigger('change')
      // emit event on change.  => input sur component => maj
        .on('change', function (event) {
          eventBus.$emit('select2Change', [$(this), $(this).val()])
          vm.$emit('input', $(this).val())
        })
    } else {
      $(this.$el)
      // init select2 "merge" data et configuration
        .select2(Object.assign({
          data: this.options,
          language: 'fr',
        }, this.configuration))
        .val(this.value)
        .trigger('change')
        .on('select2:unselecting', () => {
          $(this).data('unselecting', true)
        })
        .on('select2:opening', e => {
          if ($(this).data('unselecting')) {
            $(this).removeData('unselecting')
            e.preventDefault()
          }
        })
      // emit event on change.  => input sur component => maj
        .on('change', function (event) {
          eventBus.$emit('select2Change', [$(this), $(this).val()])
          vm.$emit('input', $(this).val())
        })
    }
    // SELECTED OPTIONS
    const sel = $(this.$el)
    const selectedIds = []
    $.each(this.options, function (index, value) {
      if (value.selected) {
        selectedIds.push(value.id)
      }
    })
    if (selectedIds.length) {
      sel.val(selectedIds).trigger('change')
    }
  },
  watch: {
    value: function (value) {
      // update value
      if (typeof (value) === 'object') {
        $(this.$el).val(value)
      } else {
        $(this.$el).val(value).trigger('change')
      }
    },
    options: function (options) {
      // update options
      const s = $(this.$el).empty().select2({
        data: options,
        ...this.configuration,
      }).val(this.value)
      if (this.optionsTriggerChange) {
        s.trigger('change')
      }
    },
  },
  destroyed: function () {
    $(this.$el).off().select2('destroy')
  },
}
</script>

<style lang="scss">
.select2.multi-long {
  .select2-selection {
    height: auto;
    padding-right: 40px;

    .select2-selection__rendered {
      padding-right: 0;
      white-space: normal;

      > li {
        display: inline-block;
        float: none;

        &.select2-search {
          display: none;
        }
        &:first-child {
          display: inline-block;
        }
      }
    }
  }
}
</style>
